import { useSelector } from "react-redux";

export function useIsStepUIFrameworkEnabled() {
    return useSelector((state: GlobalState) => state.configurationArea.features.isStepUiFrameworkEnabled);
}
